/*
 * @Author: luting
 * @Date: 2022-12-13 11:19:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-17 11:15:03
 */
import React from 'react';
import { Tag } from 'sup-ui';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { envManage } from '../store/actions';

import messages from './messages';
import styles from './index.less';

interface IProps {
  data: any;
}

const renderTopTip = (obj: any) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { cluster, isSuposInstalled } = useSelector((state: reducerStates) => state.envManage);

  switch (obj?.status?.status) {
    case 'DANGER':
      return (
        <Tag className={styles.errors} color="red" style={{ width: '100%' }}>
          <span>
            {obj.status.message}: {obj.status.details}
          </span>

          <span>{intl.formatMessage(messages.reLinking)}</span>
        </Tag>
      );
    case 'WARN':
      return (
        <Tag className={styles.warn} color="gold" style={{ width: '100%' }}>
          {obj.status.details}
        </Tag>
      );
    case 'OK':
      return !cluster && !isSuposInstalled ? (
        <Tag className={styles.warn} color="" style={{ width: '100%' }}>
          {intl.formatMessage(messages.hostTip)} “
          <span
            className={styles.hostLink}
            onClick={() => {
              dispatch(
                envManage.changeEnvStatus({
                  acitveKey: '1',
                }),
              );
            }}
          >
            {intl.formatMessage(messages.systemManager)}
          </span>
          ”。
        </Tag>
      ) : null;

    default:
      return null;
  }
};

const LinkStatusTag = (props: IProps) => {
  const { data } = props;

  return renderTopTip(data);
};

export default LinkStatusTag;
